"use strict";

const baseTemplate = document.createElement("template");
baseTemplate.innerHTML = require("./template");
const checkbox = require("../checkbox/index");

class Element extends checkbox {

    constructor() {
        super(baseTemplate);


    }

}

window.customElements.define("swiftref-toggle", Element);

module.exports = Element;
